import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getInteractions = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params

  return api.http.get('/interactions', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getInteraction = id => {
  return api.http.get(`/interactions/${id}`)
}

export const getAtcClassifications = term => {
  return api.http.get('/atc_classifications/select_search')
}

export const searchInteractions = term => {
  return api.http.get('/interactions/selec_search', {
    params: {
      term
    }
  })
}

export const getSelectInteraction = (term, callback) => {
  searchInteractions(term).then(response => {
    const { data } = response

    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteInteraction = id => {
  return api.http.delete(`/interactions/${id}`)
}

export const restoreInteraction = id => {
  return api.http.put(`/interactions/${id}/restore`)
}

export const editInteraction = interaction => {
  return api.http.put(`/interactions/${interaction._id}`, interaction)
}

export const addInteraction = interaction => {
  return api.http.post('/interactions', interaction)
}



// WEBPACK FOOTER //
// ./src/api/interactions.js